import phoneImage from '@shared/assets/images/mobile.png';
import css from '@shared/ui/v4/styles/BannerV4.module.css';
import React from 'react';

import { Header } from '@shared/ui/header';

interface Props {
  logoConfig?: Record<string, string>;
  languageConfig?: Record<string, string>;
}

const BannerV4: React.FC<Props> = ({ logoConfig, languageConfig }) => {
  return (
    <div className={css.headingBanner}>
      <Header logoConfig={logoConfig} languageConfig={languageConfig} />
      <div className={css.headingInnerImageContainer}>
        <img className={css.headingInnerImage} src={phoneImage} alt="phone" />
      </div>
    </div>
  );
};

export { BannerV4 };
